<template>
    <div class="message-container d-flex justify-content-center mb-2 incoming call inbound">
        <div class="message">
            <div class="content d-flex align-items-center" :style="styles">
                <div class="call__info">
                    <div class="call__type d-block mb-1">
                        {{ typeText }}
                    </div>
                    <div class="call__duration d-block">
                        <i class="fas fa-arrow-down"></i> {{ duration }}
                    </div>
                </div>
                <div class="call-button">
                    <i class="fas fa-phone-alt"></i>
                </div>
            </div>
            <div class="footer text-black-50">{{ beginAtFormatted }}</div>
        </div>
    </div>
</template>

<script>
  import ChatCallMessage from './chat-call-message';

  export default {
    extends: ChatCallMessage,

    computed: {
      /**
       * @return {String}
       */
      typeText() {
        return 'Incoming call';
      },

      /**
       * @return {Object}
       */
      styles() {
        const {
          'other.item.text.color': color,
          'other.item.background.color': backgroundColor
        } = {...this.brand.styles};

        // remove empty values
        return _.pickBy({color, backgroundColor}, _.identity);
      },
    },
  }
</script>
